'use strict';

module.exports = /(\w{3})[()\s\d]*$/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/var/TIMEZONE_ABBREVIATION_REG.js
// module id = 293
// module chunks = 1